<template>
  <!-- 상품 설정 관리 -->
  <div>
    <!-- 저장하기 버튼 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="상품 설정 관리">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="상품 승인 요청 사용여부">
                  <lp-radio :val.sync="value.enable_approval"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'사용안함',value:false},{label:'사용함',value:true}]"></lp-radio>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>

    <!-- 저장하기 버튼 -->
   <!-- <div class="btn-group-justify-end">
      <button class="button is-primary" @click="save">저장하기</button>
    </div>-->

  </div>
</template>

<script>
  import BreadCrumb from '../../module/common/BreadCrumb'
  import InputImg from '../../module/common/InputImg'
  import LpInputText from '../../module/common/LpInputText'
  import LpAddress from '../../module/common/LpAddress'
  import LpCheckBool from "../../module/common/LpCheckBool";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import AdminFormItem from "../../module/admin/AdminFormItem";
  import LpRadio from "../../module/common/LpRadio";

  export default {
    layout: 'Main',
    components: {
      LpRadio,
      AdminFormItem,
      LpAdmDropInput,
      LpCheckBool,

      InputImg,
      LpInputText,
      LpAddress
    },
    created() {
      this.$axios.get('admin/service/product/setting').then(res=>{
        this.value = res.data;
      })
    },
    data () {
      return {
        value: {
          enable_approval: false
        }
      }
    },
    methods: {
      save() {
        this.$axios.patch('admin/service/product/setting', this.value).then(res=>{
          if(res.status === 200){
            this.toast('저장되었습니다.');
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
//@import '~assets/css/reset'
//@import '~assets/css/lp_main'


</style>
